import { CATEGORY_SLUG } from "@/shared/domains";

export const EVENT_PREFIX = {
  NONE: "",
  QUESTIONNAIRE: "questionnaire-",
  FUNNEL: "funnel-",
} as const;

export const ANALYTICS_PROVIDER = {
  CUSTOMER_IO: "customer-io",
  EVERFLOW: "everflow",
  GOOGLE_TAG_MANAGER: "google-tag-manager",
  MOUSEFLOW: "mouseflow",
  QUORA: "quora",
  TATARI: "tatari",
} as const;

export const ANALYTICS_PARAMS = {
  EF_TRANSACTION_ID: "_ef_transaction_id",
  EVERFLOW_ORDER_ID: "oid",
  EVERFLOW_AFFILIATE_ID: "affid",
  EVERFLOW_SOURCE_ID: "source_id",
  EVERFLOW_UID: "uid",
  EVERFLOW_SUB1: "sub1",
  EVERFLOW_SUB2: "sub2",
  EVERFLOW_SUB3: "sub3",
  EVERFLOW_SUB4: "sub4",
  EVERFLOW_SUB5: "sub5",
  CUSTOMER_IO_ID: "cio_id",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CONTENT: "utm_content",
} as const;

export const CUSTOMER_IO_EVENT = {
  PRICES_SELECTED: "prices_selected",
  CHECKOUT_PAGE_VIEWED: "checkout_page_viewed",
  SHOP_PAGE_VIEWED: "shop_page_viewed",
  SHOP_SUMMARY_PAGE_VIEWED: "shop_summary_page_viewed",
  PAYMENT_FAILED: "payment_failed",
  PAYMENT_COMPLETED: "purchase",
  USER_LOGGED_IN: "user_logged_in",
  USER_LOGGED_OUT: "user_logged_out",
  USER_PROFILE_UPDATED: "user_profile_updated",
  BMI_PAGE_VIEWED: "bmi_page_viewed",
  BMI_DISQUALIFIED: "bmi_disqualified",
  DQ_PAGE_VIEWED: "dq_page_viewed",
  HEALTH_DISQUALIFIED: "health_disqualified",
  NAME_PAGE_VIEWED: "name_page_viewed",
  EMAIL_PHONE_PAGE_VIEWED: "email_phone_page_viewed",
  PLAN_PAGE_VIEWED: "plan_page_viewed",
  PRODUCT_SELECTED: "product_selected",
  PAYMENT_METHOD_SELECTED: "payment_method_selected",
  COMPLETE_PURCHASE_CLICKED: "complete_purchase_clicked",
  CREATE_PASSWORD_VIEWED: "create_password_viewed",
  BILLING_ADDRESS_STARTED: "billing_address_started",
  AFFILIATE_ID_CAPTURED: "affiliate_id_captured",
} as const;

export const CUSTOMER_IO_CATEGORY_SLUG = {
  [CATEGORY_SLUG.WEIGHT_LOSS]: CATEGORY_SLUG.WEIGHT_LOSS,
  [CATEGORY_SLUG.HAIR_GROWTH]: CATEGORY_SLUG.HAIR_GROWTH,
  [CATEGORY_SLUG.LONGEVITY]: CATEGORY_SLUG.LONGEVITY,
  [CATEGORY_SLUG.MICRODOSING]: "microdose",
  [CATEGORY_SLUG.TESTOSTERONE]: "trt",
} as const;

export const GOOGLE_TAG_MANAGER_EVENT = {
  BEGIN_CHECKOUT: "begin_checkout",
  BMI_PAGE_VIEWED: "bmi_page_viewed",
  BMI_DISQUALIFIED: "bmi_disqualified",
  DQ_PAGE_VIEWED: "dq_page_viewed",
  HEALTH_DISQUALIFIED: "health_disqualified",
  NAME_PAGE_VIEWED: "name_page_viewed",
  EMAIL_PHONE_PAGE_VIEWED: "email_phone_page_viewed",
  PLAN_PAGE_VIEWED: "plan_page_viewed",
  PRODUCT_SELECTED: "product_selected",
  PRICES_SELECTED: "prices_selected",
  PAYMENT_METHOD_SELECTED: "payment_method_selected",
  COMPLETE_PURCHASE_CLICKED: "complete_purchase_clicked",
  PAYMENT_COMPLETED: "purchase",
  PAYMENT_FAILED: "payment_failed",
  CREATE_PASSWORD_VIEWED: "create_password_viewed",
  BILLING_ADDRESS_STARTED: "billing_address_started",
} as const;

export const QUORA_EVENT = {
  PURCHASE: "Purchase",
  ADD_TO_CART: "AddToCart",
  ADD_PAYMENT_INFO: "AddPaymentInfo",
} as const;

export const EVERFLOW_CUSTOM_EVENT_ID = {
  ADD_TO_CART: 1,
  INITIATE_CHECKOUT: 2,
} as const;

export const MOUSEFLOW_EVENT = {
  BMI_DISQUALIFIED: "bmi_disqualified",
  HEALTH_DISQUALIFIED: "health_disqualified",
} as const;

export const MOUSEFLOW_FORM_SUBMIT = {
  ATTEMPT: "formSubmitAttempt",
  SUCCESS: "formSubmitSuccess",
  FAILURE: "formSubmitFailure",
} as const;

export const MOUSEFLOW_VARIABLE = {
  GENDER: "gender",
  GLP1_USER: "glp1_user",
  BMI_GROUP: "bmi_group",
} as const;
